module.exports = __webpack_public_path__ + "img/xuanfutu.2594f391.png";